import { idtype } from "querypieces";

export default `
  ...on pageBuilder_newsFeed_BlockType {
    ${idtype}
    heading
    label
  }
`;
